module.exports = __webpack_public_path__ + "img/hero-heading.e3f26b96.png";